module.exports = __webpack_public_path__ + "assets/images/In-App.svg";